import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "AeroAcres sprayed 80 acres of our avocado grove in a single morning — something that would've taken our ground crew four days. Coverage report was professional, drift was zero.",
    name: "Carlos Mendez",
    role: "Mendez Family Groves · Homestead",
    avatar: "https://images.pexels.com/photos/36998122/pexels-photo-36998122.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=400",
  },
  {
    quote:
      "We had a fungal outbreak in our tomato field after a wet week. Their team was over the field within 36 hours and we saved the crop. These guys are the real deal.",
    name: "Janelle Brooks",
    role: "Brooks Farms · Florida City",
    avatar: "https://images.unsplash.com/photo-1628600881785-20238ebee731?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxmYXJtZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODA1NzI4MzZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    quote:
      "Lower chemical bill, faster turnarounds, and no tractor compaction in our nursery. We've put AeroAcres on a recurring monthly schedule.",
    name: "Rashid Patel",
    role: "Redland Ornamentals · Miami-Dade",
    avatar: "https://images.unsplash.com/photo-1617490439585-b855defbe904?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxmYXJtZXIlMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODA1NzI4MzZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32 bg-muted/40 relative">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mb-14">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-accent mb-4">Loved by Florida farmers</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-primary font-bold leading-tight">
            Trusted by growers across <span className="text-accent">Miami-Dade.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-card border border-border rounded-3xl p-7 shadow-card hover:shadow-card-hover transition-shadow relative"
            >
              <Quote className="h-8 w-8 text-accent/40 absolute top-6 right-6" />
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="h-4 w-4 fill-accent text-accent" />
                ))}
              </div>
              <p className="text-foreground/85 leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-border">
                <img src={t.avatar} alt={t.name} loading="lazy" className="h-11 w-11 rounded-full object-cover" />
                <div>
                  <div className="font-semibold text-primary text-sm">{t.name}</div>
                  <div className="text-xs text-muted-foreground">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
